import BaseException from "exceptions/BaseException";

export default class UnknownTabMappingException extends BaseException {
    readonly name = 'UnknownTabMappingException';
}
